<template lang="pug">
.container
  header
    main-header(
      :notificacao="false"
      :hasListagemModelo="false"
    )
  .container-conversa
    .card.fullWidth.cardPadding
      informacoes-conversa(v-if="idConversa" :idConversa="idConversa", @conversa="setConversa")
      el-col.container-input
        validation-provider(rules="required", v-slot="{ errors }", name="Mensagem", mode="eager")
          app-label(label="Mensagem:", :required="true")
          div.sugestao(v-if="assuntoConversa === 'Solicitação de cópia do processo'")
            span Sugestão de resposta ao Consultor Externo - Diverso: Favor enviar o comprovante de pagamento do boleto em resposta à essa mensagem.
          app-text-editor(
            v-model="conversa.mensagem"
            :class="{'input erro': errors && errors.length > 0 ? true : false}"
            :config="config"
          )
          span.help.erro {{ errors[0] }}
      el-col.drop
        app-anexo(
          :id="'upload-atualizacao-base'"
          @uploadFile="uploadFile",
          :files="anexos",
          @removeFile="removeFile",
          @downloadDocumentoCadastro="getDownload"
        )
      el-col
        app-buttons-cadastro.btns(
          :isPrimeiroPasso="true",
          :isUltimoPasso="true",
          :showButtonFinalizar="false"
          :showButtonEnviar="(!!idConversa || !!conversa.assunto) && !!conversa.mensagem"
          :showButtonDownload="isAmapa"
          @cancelar="cancelar",
          @download="download",
          @enviar="enviar"
        )
</template>

<script>
import AppTextEditor from '@/components/AppTextEditor'
import AppLabel from '@/components/AppLabel'
import AppAnexo from '@/components/AppAnexo'
import axios from '@/utils/api'
import AppButtonsCadastro from '@/components/AppButtonsCadastro'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import InformacoesConversa from '@/screens/central/components/comunicacao/InformacoesConversa'
import MainHeader from '@/components/MainHeader'
import FileSaver from 'file-saver'
import { mapActions, mapGetters } from 'vuex'

export default {
  mixins: [
    AppNotificacao
  ],

  components: {
    AppTextEditor,
    AppLabel,
    AppAnexo,
    AppButtonsCadastro,
    InformacoesConversa,
    MainHeader
  },

  computed: {
    ...mapGetters({
      usuario: 'auth/usuarioLogado'
    }),
    isAmapa () {
      return process.env.ESTADO === 'ap'
    }
  },

  mounted () {
    if (process.env.ESTADO === 'ap') {
      const assuntoCopiaAp = {
        codigo: 'SOLICITACAO_DE_COPIA_DO_PROCESSO',
        nome: 'Solicitação de cópia do processo'
      }
      this.assuntos.splice(4, 0, assuntoCopiaAp)
    }
  },

  data () {
    return {
      assuntos: [
        {
          codigo: 'EM_QUAL_SETOR_SE_ENCONTRA_MEU_PROCESSO',
          nome: 'Em qual setor se encontra meu processo?'
        },
        {
          codigo: 'PORQUE_MEU_PROCESSO_ESTA_PARADO',
          nome: 'Por que meu processo está parado?'
        },
        {
          codigo: 'QUERO_DECLARACAO_TRAMITE_PROCESSUAL',
          nome: 'Quero declaração de tramite processual'
        },
        {
          codigo: 'INFORMAR_PROBLEMA_CADASTRO',
          nome: 'Informar problema no cadastro'
        },
        {
          codigo: 'DENUNCIAR_SERVIDOR',
          nome: 'Denunciar servidor(a)'
        },
        {
          codigo: 'OUTRAS_OPCOES',
          nome: 'Outros'
        }
      ],
      conversa: {
        assunto: '',
        mensagem: ''
      },
      assuntoConversa: '',
      anexos: [],
      config: {
        lang: 'pt-BR',
        placeholder: 'Digite o texto...',
        minHeight: 200,
        height: 350,
        maxHeight: 350
      },
      idConversa: this.$route.params.idConversa
    }
  },
  methods: {
    ...mapActions({
      responderMensagem: 'conversa/addMensagem',
      baixarPdfHistoricoConversa: 'processos/baixarHistoricoConversa'
    }),

    setConversa (conversa) {
      this.assuntoConversa = conversa.assunto
    },

    async uploadFile (file) {
      this.anexos = [...this.anexos, { key: file.response, nome: file.name }]
    },

    removeFile (file) {
      this.anexos.splice(this.anexos.findIndex(f => f === file), 1)
    },

    async getDownload (documento) {
      const file = await axios({
        method: 'POST',
        url: `documento/file`,
        data: documento,
        responseType: 'blob'
      })
      FileSaver.saveAs(file, documento.nome)
    },

    cancelar () {
      this.confirmBox('Você tem certeza que deseja cancelar? Todos os dados não salvos serão perdidos.', this.$messages.TITULO_WARNING,
        () => {
          this.$router.push({
            name: 'ouvidoria/home'
          })
        },
        () => {
        }, 'Sim', 'Não')
    },

    async enviar () {
      const payloadMensagem = {
        assunto: this.conversa.assunto,
        tipo: 'OUVIDORIA',
        mensagemList: [
          {
            anexoList: this.anexos,
            conteudo: this.conversa.mensagem
          }
        ],
        id: this.idConversa
      }

      this.loading = true

      await this.responderMensagem(payloadMensagem)

      this.loading = false

      this.$router.push({ name: 'ouvidoria/home' })
    },
    async download () {
      await this.baixarPdfHistoricoConversa(this.idConversa)
    }
  }

}
</script>

<style lang="scss" scoped>
.container-conversa {
  display: flex;
}
.fullWidth {
  width: 100%;
}
.cardPadding {
  padding: 23px;
}
.marginTop {
  margin-top: 0;
}
.drop {
  margin-top: 10px;
}
.btns {
  padding-left: 0 !important;
}
.sugestao {
  font-size: small;
  color: dimgray;
  margin-bottom: 2%;
}
</style>



// WEBPACK FOOTER //
// src/screens/ouvidoria/ResponderConversa.vue